
import { Vue, Component, Mixins } from 'vue-property-decorator'
import { StateAuthorItems } from '@/helpers/state'

@Component
export default class ItemAuthorActionsAsmtOptions extends Mixins(Vue, StateAuthorItems) {
  get asmtUpdateOption() {
    return this.authorItemRevUpdateOption
  }

  set asmtUpdateOption(v) {
    this.authorSetItemRevUpdateOption(v)
  }

  mounted() {
    // Set the update assessments option to user
    // if authoring has passage aff change.
    if (this.authorHasPassageAffChanges) {
      this.authorSetItemRevUpdateOption('user')
    }
  }
}
